import { Loader } from 'components/Loader';
import { getStepPage } from 'constants/steps';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';

export default function OnBoarding() {
  const { user } = useAppSelector(selectAccountDetails);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/on-boarding') {
      navigate('/on-boarding/basic-info');
    }
  }, [navigate, pathname]);

  useEffect(() => {
    if (user && user?.isStepCompleted) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    if (user && user?.nextStep) {
      navigate(`/on-boarding/${getStepPage(user?.nextStep)}`);
    }
  }, []);

  return (
    <div className="w-full">
      {!user ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <div className="my-10 w-full">
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
}
